import {AnyEvent, JOB_VARIATION_ITEM_REORDERED, JobVariationItemReorderedEvent} from '../type';

export default function jobVariationItemReordered(payload: JobVariationItemReorderedEvent['payload']): AnyEvent {
  return {
    type: JOB_VARIATION_ITEM_REORDERED,
    payload,
  }
}